import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

import type { Config } from 'server/types';

const DSN = 'https://afff0c0b9fea4021b656ee39a079ba04@sentry-public.vulners.com//8';

export function initSentry(config: Config) {
    if (!config.isBot && config.environment === 'stable') {
        Sentry.init({
            dsn: DSN,
            integrations: [new BrowserTracing() as never],
            environment: config.environment,
            // We recommend adjusting this value in production, or using tracesSampler
            // for finer control
            tracesSampleRate: 1.0
        });
    }
}
